export class AuthApiError extends Error {
  readonly status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = 'AuthApiError';
    this.status = status;
  }
}

export interface LoginResponse {
  access_token: string;
  expires_in: number;
  subject: string;
  preferred_username: string;
}

export async function login(
  baseUrl: string,
  username: string,
  password: string,
): Promise<LoginResponse> {
  const res = await fetch(`${baseUrl}/v1/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = (await res.json()) as { detail?: string };
      if (body.detail) detail = body.detail;
    } catch {
      /* ignore */
    }
    throw new AuthApiError(res.status, detail);
  }

  return res.json() as Promise<LoginResponse>;
}
